export default "__VITE_ASSET__l6kOg5ss__"